<ng-container *ngIf="titleInsurance$ | async as titleInsurance">
	<div class="flex items-center gap-2">
		<h3 class="mr-3">Title insurance</h3>
	</div>
	<app-mms-mortgage-warning></app-mms-mortgage-warning>
	<div class="flex justify-center mb-10">
		<div class="flex flex-col items-center">
			<div class="flex w-32 h-16">
				<img src="/assets/images/integrations/title-plus-logo.svg" />
			</div>
			<span
				*ngIf="allowSwitchProviders && !loading"
				class="text-sm text-green underline cursor-pointer mb-3"
				(click)="selectInsuranceProvider()"
				[testHook]="testHooks.SelectInsuranceProviderSpan"
				>Switch provider</span
			>
			<app-title-insurance-toolbar
				[provider]="titleInsurance?.provider"
				[status]="status"
				[orderValid]="orderValid"
				(openModal)="submitFile()"
				(cancelOrder)="cancel()"
			></app-title-insurance-toolbar>
			<app-missing-fields-notif
				*ngIf="
					status && status !== TitlePlusStatus.NOT_SUBMITTED && !orderValid
				"
				[missing]="missing"
			></app-missing-fields-notif>
		</div>
	</div>

	<div class="flex gap-2 items-center justify-between mt-1">
		<hr class="w-5/12 mt-2" />
		<p class="text-lg font-bold text-center">Order summary</p>
		<hr class="w-5/12 mt-2" />
	</div>

	<div *ngIf="status" class="flex gap-2 justify-center items-center mt-3">
		<div class="border-r border-grey-veryLight pr-2">
			<p>
				<span class="text-gray">Order number: </span>
				<span class="font-bold"> {{ titleInsurance?.referenceNumber }} </span>
			</p>
		</div>
		<div
			class="border-r border-grey-veryLight pr-2"
			*ngIf="titleInsurance?.orderedOn"
		>
			<p>
				<span class="text-gray">Order date: </span>
				<span class="font-bold">
					{{ titleInsurance?.orderedOn | date: 'mediumDate' }}
				</span>
			</p>
		</div>
		<div *ngIf="effectiveDate$ | async">
			<p>
				<span class="text-gray">Effective date: </span>
				<span class="font-bold">
					{{ effectiveDate$ | async | date: 'mediumDate' }}
				</span>
			</p>
		</div>
	</div>

	<div
		*ngIf="status !== TitlePlusStatus.SUBMITTED"
		class="flex mt-10 justify-center mx-4"
	>
		<app-step-progress-nav
			class="stepper"
			[steps]="steps"
			[current]="currentStep"
			[testHook]="testHooks.StepProgressNav"
		></app-step-progress-nav>
	</div>

	<app-title-plus-not-submitted
		*ngIf="!status || status === TitlePlusStatus.NOT_SUBMITTED"
		[missing]="missing"
		[orderValid]="orderValid"
		[canSubmit]="canSubmit"
		[changePropertyButtonText]="changePropertyButtonText"
		[outOfOntario]="outOfOntario"
		[isOther]="isOther"
		[isLeasehold]="isLeasehold"
		[isMobileHome]="isMobileHome"
		[isCommercial]="isCommercial"
		[showPriorityWarning]="showPriorityWarning"
		[status]="status"
	></app-title-plus-not-submitted>
	<app-title-plus-under-review
		*ngIf="
			status === TitlePlusStatus.UNDER_REVIEW ||
			status === TitlePlusStatus.USER_ACTION_REQUIRED
		"
		[matterId]="matterId"
		[thirdPartyId]="thirdPartyId"
		[status]="status"
	></app-title-plus-under-review>
	<app-title-plus-issued
		*ngIf="status === TitlePlusStatus.ISSUED"
	></app-title-plus-issued>
	<app-title-plus-cancelled
		*ngIf="status === TitlePlusStatus.CANCELLED"
	></app-title-plus-cancelled>
	<app-title-plus-declined
		*ngIf="
			status === TitlePlusStatus.DECLINED || status === TitlePlusStatus.DELETED
		"
		[status]="status"
	></app-title-plus-declined>
</ng-container>
